module.exports = __webpack_public_path__ + "66554c2ea7b326d0c3d53449adf2a6a6.jpg";